module.exports = __webpack_public_path__ + "img/add-s-3.586ce41d.png";